import { render, staticRenderFns } from "./CellRendererList.vue?vue&type=template&id=2b96c1a7&"
import script from "./CellRendererList.vue?vue&type=script&lang=js&"
export * from "./CellRendererList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports